import { memo } from "react";
import { useChatComposer } from "../hooks/useChatComposer";
import ChatComposerAttachButton from "./ChatComposerAttachButton";
import ChatComposerDisclaimer from "./ChatComposerDisclaimer";
import ChatComposerFilePreview from "./ChatComposerFilePreview";
import ChatComposerSendControl from "./ChatComposerSendControl";
import ChatComposerTextarea from "./ChatComposerTextarea";

const ChatComposer = ({
  t,
  variant = "compact",
  inputValue,
  onInputChange,
  onKeyDown,
  onSend,
  onFileSelect,
  onFileChange,
  onRemoveFile,
  fileInputRef,
  selectedFile,
  loading,
  hasPromptPermission,
}) => {
  const {
    isCompact,
    isRtl,
    textareaRef,
    previewUrl,
    maxTextareaHeight,
    attachButtonSize,
    sendButtonSize,
  } = useChatComposer({ variant, inputValue, selectedFile });

  return (
    <div
      className={`absolute bottom-0 inset-x-0 bg-gradient-to-t from-surface via-surface to-surface/90 border-t border-border-light flex flex-col flex-shrink-0 z-10 ${
        isCompact ? "p-3 gap-2" : "p-4 gap-3"
      }`}
    >
      <ChatComposerFilePreview
        t={t}
        selectedFile={selectedFile}
        previewUrl={previewUrl}
        onRemoveFile={onRemoveFile}
        isCompact={isCompact}
      />

      <div
        className={`flex items-end gap-2 bg-surface-muted border border-border-muted rounded-[14px] shadow-[0_3px_4px_rgba(0,0,0,0.03)] w-full ${
          isCompact ? "p-1.5" : "py-2 ps-3 pe-2"
        } ${!isCompact ? "max-w-4xl mx-auto" : ""}`}
      >
        <ChatComposerAttachButton
          t={t}
          fileInputRef={fileInputRef}
          onFileChange={onFileChange}
          onFileSelect={onFileSelect}
          loading={loading}
          hasPromptPermission={hasPromptPermission}
          isCompact={isCompact}
          buttonSize={attachButtonSize}
        />
        <ChatComposerTextarea
          t={t}
          textareaRef={textareaRef}
          inputValue={inputValue}
          onInputChange={onInputChange}
          onKeyDown={onKeyDown}
          loading={loading}
          hasPromptPermission={hasPromptPermission}
          maxTextareaHeight={maxTextareaHeight}
          isCompact={isCompact}
        />
        <ChatComposerSendControl
          t={t}
          onSend={onSend}
          loading={loading}
          hasPromptPermission={hasPromptPermission}
          isRtl={isRtl}
          buttonSize={sendButtonSize}
        />
      </div>

      <ChatComposerDisclaimer t={t} isCompact={isCompact} />
    </div>
  );
};

export default memo(ChatComposer);
